export default __webpack_public_path__ + "static/media/bull_bear_fight.0ff904d2.png";